
export default class CardPointeDataModel {
    csvData: string = "";    
    requireSecurityCode: boolean = false;
    

    static from(json: string): CardPointeDataModel {
        return Object.assign(new CardPointeDataModel(), json);
    }
}
